export class TransferDevice {
    requestDeviceId: number;
    serialNumber: string;

    constructor(requestDeviceId: number, serialNumber: string) {
        this.requestDeviceId = requestDeviceId;
        this.serialNumber = serialNumber;
    }
}